import axios, { BUSINESS_PAYMENT_PREFIX } from 'src/clients/axios';
import { GetApproverMakerResponse } from 'src/models';

export function getApproverMaker(isApprover: boolean) {
  return axios.request<GetApproverMakerResponse>({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}/approval/v2/maker-approvers?isApprover=${isApprover}`,
  });
}
